import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    cart: []
}

export const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        addToCart: (state, action) => {
            const itemInCart = state.cart.find((item) => item._id === action.payload._id);
            if (itemInCart) {
                // itemInCart.quantity++;
                // alert("already exist")
                const index = state.cart.findIndex(item => item._id === action.payload._id);
                state.cart[index].quantity++;

            } else {
                state.cart.push({ ...action.payload, quantity: 1 });

            }
        },

        addWithQuantity: (state, action) => {
            console.log("Payload received:", action.payload); // Debugging

            const itemInCart = state.cart.find((item) => item.variant_name === action.payload.variant_name);

            if (itemInCart) {
                itemInCart.quantity += action.payload.quantity || 1;
            } else {
                state.cart.push({ ...action.payload, quantity: action.payload.quantity || 1 });
            }

            state.cart = [...state.cart]; // Force Redux to detect state change
            console.log("Updated Cart:", state.cart);
        },


        removeFromCart: (state, action) => {
            state.cart = state.cart.filter(item => item.id !== action.payload.id);
        },

        removeAllCart: (state, action) => {
            state.cart = []
        },

        increment: (state, action) => {
            state.cart = state.cart.map(item =>
                item.id === action.payload.id
                    ? { ...item, quantity: item.quantity + 1 }
                    : item
            );
        },

        decrement: (state, action) => {
            state.cart = state.cart.map(item =>
                item.id === action.payload.id
                    ? { ...item, quantity: item.quantity > 1 ? item.quantity - 1 : 0 }
                    : item
            ).filter(item => item.quantity > 0);
        },

    },
})


export const { increment, decrement, addToCart, removeFromCart, addWithQuantity, removeAllCart } = cartSlice.actions

export default cartSlice.reducer